import { MessageOutlined } from "@ant-design/icons";

// Лента с коментара към поръчката в списъчния изглед — стои над първия ред
// на поръчката (само ако има коментар). Чисто визуална: без селекция/действия.

interface OrderCommentRowProps {
  // Общият grid template на списъка — динамичен, затова е inline style.
  gridTemplate: string;
  tableLabel: string;
  comment: string;
}

const OrderCommentRow = ({
  gridTemplate,
  tableLabel,
  comment,
}: OrderCommentRowProps) => {
  return (
    <div
      // Клик по лентата не е „фон" — не сваля селекцията
      onClick={(clickEvent) => clickEvent.stopPropagation()}
      className="grid cursor-default items-center gap-x-[10px] bg-warn-tint py-[7px] pl-[18px] pr-[14px]"
      style={{ gridTemplateColumns: gridTemplate }}
    >
      <div className="flex items-center justify-center">
        <MessageOutlined className="text-[19px] text-brand-deep-ink" />
      </div>

      <div className="truncate text-[15.5px] font-bold tracking-[-0.2px] text-ink">
        {tableLabel}
      </div>

      <div className="col-[3/-1] min-w-0 break-words text-[15.5px] font-semibold italic leading-[1.25] text-ink-2">
        {comment}
      </div>
    </div>
  );
};

export default OrderCommentRow;
